/**
 * API URL索引文件
 * 导出所有API URL
 */
import authUrls from './auth';
import resultsUrls from './results';

export default {
  ...authUrls,
  ...resultsUrls
}; 